module.exports = __webpack_public_path__ + "static/media/19-11.1e9a33b2.mp3";